import { useAuth } from '../hooks/useAuth';

const UserProfile = () => {
  const { user } = useAuth();
  
  const userInitial = user?.email?.[0]?.toUpperCase() || 'U';
  
  return (
    <div className="flex items-center space-x-4">
      <div 
        className="w-10 h-10 bg-[#ff8c42] rounded-full flex items-center justify-center text-white font-medium cursor-pointer"
      >
        {userInitial}
      </div>
      
      <div>
        <h2 className="text-xl font-bold text-[#694e42]">
          Welcome, {user?.user_metadata?.full_name || user?.email?.split('@')[0]}
        </h2>
        <p className="text-[#8a7266]">{user?.email}</p>
      </div>
    </div>
  );
};

export default UserProfile;